import { Component, OnInit, Inject } from '@angular/core'
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PlacementService } from '../_services/placementservice';
import { ErrorModalHelperService } from '../_helpers/error-modal-helper/error-modal-helper.service';
import { ColumnDef } from './data-table/data-table.model';

@Component({
    selector: 'submission-history-records',
    templateUrl: 'submission-history-records.html',
    styleUrls: ['submission-history-records.css'],
    standalone: false
})
export class SubmissionHistoryRecords implements OnInit {
  public columns: ColumnDef<any>[] = [
    { field: 'createdDate', header: 'Date', type: 'date' },
    { field: 'comment', header: 'Comment' },
    { field: 'createdBy', header: 'Created By' }
  ];
  public rows: any[] = [];
  loading: boolean = false;
  constructor(public dialog: MatDialog,
    private placementService: PlacementService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private errorModalHelper: ErrorModalHelperService) { }

  ngOnInit() {
    this.placementService.GetSubmissionHistory(this.data).subscribe((result: any) => {
      this.rows = result || [];
    },
      error => {
        this.errorModalHelper.show(error.message, error);
      }
    );

  }
}
